import { ofetch, FetchError } from 'ofetch';
import { ApiClientError } from '../api/errors';
import { createDebugLogger } from '../utils/debug';
import { attachBearer } from '../auth/attachBearer';

const dlog = createDebugLogger('probe');

/**
 * Probe-API-Client. Immer über den BFF-Proxy `/proxy/probe/...`. Der BFF
 * injiziert server-seitig den statischen Service-Bearer + das
 * GATEWAY_SHARED_SECRET — das Frontend sendet KEINEN Auth-Header (Probe
 * verlangt `probe:*`-Scopes, die der Operator-CORE-Bearer nicht trägt).
 */
const raw = ofetch.create({
  baseURL: '/proxy/probe',
  onRequest(ctx) { attachBearer(ctx); dlog('→', ctx.request); }, // #501
  onResponse({ request, response }) { dlog('←', request, response.status); },
});

export async function probeFetch(path, opts = {}) {
  try {
    return await raw(path, opts);
  } catch (err) {
    if (err instanceof FetchError) {
      const data = err.data;
      throw new ApiClientError({
        code: data?.error?.code ?? data?.title ?? 'probe_request_failed',
        message: data?.error?.message ?? data?.detail ?? err.message,
        status: err.response?.status ?? 0,
        details: data?.errors ?? data?.error?.details,
      });
    }
    throw err;
  }
}

export function isProbeProxyEnabled() {
  if (typeof window === 'undefined') return false;
  return window.__ORBIT_CONFIG__?.probeProxyEnabled === true;
}
